

<div class="dimensions">
    <div class="navBarView d-flex justify-content-around align-items-center">
        <h4>Journal Buddy</h4>
    </div>
    <div class="bodyContent d-flex flex-column justify-content-top">
        <div class="height10">
            <div class="w-100 ">
                <img src="../../assets/back.png" class="mt-4 ml-4 d-flex justify-content-left align-items-center backSizing" alt="backIcon" (click)="goBack()">
                <div class=" d-flex justify-content-center align-items-top"><u><b>25 October 2020</b></u></div>
            </div>
        </div>
        <div class="height70 borderbox p-2 " >
            {{text}} 
        </div>
        
        <div >
            <div class="w-100 d-flex justify-content-center">
                <img src="../../assets/play.png" class="mt-4 mr-4 folderSizing" alt="backIcon" (click)="goBack()">
                
            </div>
        </div>
    </div>
    
</div>